import SearchIcon from "@mui/icons-material/Search";
import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { MyButton } from "../../atoms";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import { PRIMARY } from "../../../utils/constansColors";

import {
  getExcoRTRW,
  createExcoRTRW,
} from "../../../config/Redux/ExcoPusat/actions";
import ExcoCardView from "../../molecules/ExcoCardView";
import ModalAddRTRW from "./ModalAddRTRW";

const useStyles = makeStyles({
  root: {
    "& .Mui-selected": {
      backgroundColor: PRIMARY,
      color: "white",
      border: "none",
    },
  },
});

const ExcoRTRW = ({ isLocked }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { daerahId } = useParams();
  const [searchInput, setSearchInput] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [limit] = useState(10);
  const searchTimeout = useRef(null);

  // Redux state
  const { dataExcoRTRW } = useSelector((state) => state.excopusat);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fetchData = () => {
    if (daerahId) {
      const id_kelurahan = daerahId;
      dispatch(
        getExcoRTRW({
          id_kelurahan,
          page,
          limit,
          search,
        }),
      );
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, daerahId, page, limit, search]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    setPage(1);
    if (searchTimeout.current) clearTimeout(searchTimeout.current);
    searchTimeout.current = setTimeout(() => {
      setSearch(value);
    }, 500);
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const handleAddSubmit = async (newData) => {
    setLoading(true);
    await dispatch(createExcoRTRW(newData));
    fetchData(); // Refresh list after creation
    setLoading(false);
    setOpen(false);
  };

  return (
    <div>
      {/* Header / Filter */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", flex: 1 }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <input
              type="text"
              placeholder="Search by RT/RW"
              value={searchInput}
              onChange={handleSearchChange}
              style={{
                height: "42px",
                padding: "0 16px",
                borderRadius: "8px 0 0 8px",
                border: "1px solid #e0e0e0",
                borderRight: "none",
                outline: "none",
                width: "300px",
                fontSize: "13px",
                color: "#424242",
                boxSizing: "border-box",
              }}
            />
            <div
              style={{
                height: "42px",
                width: "46px",
                backgroundColor: "#ffffff",
                border: "1px solid #e0e0e0",
                borderRadius: "0 8px 8px 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <SearchIcon style={{ color: "#757575", fontSize: "20px" }} />
            </div>
          </div>
        </div>
        {!isLocked && (
        <MyButton
          backgroundColor="#F06524"
          backgroundColorHover="#d14d11"
          color="#FFFFFF"
          onClick={handleOpen}
          style={{
            height: "42px",
            textTransform: "none",
            fontWeight: "500",
            fontSize: "14px",
            borderRadius: "8px",
          }}
        >
          + Tambah Komisaris RT/RW
        </MyButton>
        )}
      </div>

      {/* List using ExcoCardView */}
      <ExcoCardView
        data={dataExcoRTRW?.data?.data || []}
        type="rtrw"
        nameExco="Komisaris RT/RW"
        loading={loading || dataExcoRTRW?.loading}
      />

      {/* Pagination */}
      {dataExcoRTRW?.data?.data?.length > 0 && (
        <div
          style={{
            justifyContent: "flex-end",
            display: "flex",
            marginTop: "10px",
          }}
        >
          <Pagination
            count={Math.ceil((dataExcoRTRW?.data?.total_items || 0) / 10)}
            variant="outlined"
            shape="rounded"
            page={page}
            onChange={handlePageChange}
            className={classes.root}
          />
        </div>
      )}

      {/* Modal Tambah RT/RW */}
      <ModalAddRTRW
        open={open}
        onClose={handleClose}
        onSubmit={handleAddSubmit}
      />
    </div>
  );
};

export default ExcoRTRW;
